import store from "../../redux/store";
import * as actions from "./DashboardManagerType";
import { handleAxiosGet } from "../axiosHelper"; // adjust path if needed

const formatDate = (date) =>
  date instanceof Date ? date.toISOString().split("T")[0] : date;

const apiBaseUrl = "/api/dashboardmanager";

// Collection Tabs (with date)
export const getCollectionVsTarget = async (role, user, fromDate, toDate) => {
  const endPoint = `${apiBaseUrl}/getCollectionVsTarget/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint, {
    fromDate: formatDate(fromDate),
    toDate: formatDate(toDate),
  });

  if (responseData) {
      store.dispatch({
      type: actions.SET_COLLECTION_VS_TARGET,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getCollectionCustomerwise = async (role, user, fromDate, toDate) => {
  const endPoint = `${apiBaseUrl}/getCollectionCustomerwise/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint, {
    fromDate: formatDate(fromDate),
    toDate: formatDate(toDate),
  });
  if (responseData) {
    store.dispatch({
      type: actions.SET_COLLECTION_CUSTOMERWISE,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getCollectionAgingwiseWithoutTax = async (role, user, fromDate, toDate) => {
  const endPoint = `${apiBaseUrl}/getCollectionAgingwiseWithoutTax/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint, {
    fromDate: formatDate(fromDate),
    toDate: formatDate(toDate),
  });
  if (responseData) {
    store.dispatch({
      type: actions.SET_COLLECTION_AGINGWISE_WOTAX,
      payload: { list: responseData },
    });
  }
  return responseData;
};

// OS/OD Tabs (no date)
export const getOSOD = async (role, user) => {
  const endPoint = `${apiBaseUrl}/getOSOD/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint);
  if (responseData) {
    store.dispatch({
      type: actions.SET_OSOD,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getOSODCustomerwise = async (role, user) => {
  const endPoint = `${apiBaseUrl}/getOSODCustomerwise/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint);
  if (responseData) {
    store.dispatch({
      type: actions.SET_OSOD_CUSTOMERWISE,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getOSODExecutivewise = async (role, user) => {
  const endPoint = `${apiBaseUrl}/getOSODExecutivewise/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint);
  if (responseData) {
    store.dispatch({
      type: actions.SET_OSOD_EXECUTIVEWISE,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getOnAccountExecutivewise = async (role, user) => {
  const endPoint = `${apiBaseUrl}/getOnAccountExecutivewise/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint);
  if (responseData) {
    store.dispatch({
      type: actions.SET_ONACCOUNT_EXECUTIVEWISE,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getOnAccountCustomerwise = async (role, user) => {
  const endPoint = `${apiBaseUrl}/getOnAccountCustomerwise/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint);
  if (responseData) {
    store.dispatch({
      type: actions.SET_ONACCOUNT_CUSTOMERWISE,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getODAgewise = async (role, user) => {
  const endPoint = `${apiBaseUrl}/getODAgewise/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint);
  if (responseData) {
    store.dispatch({
      type: actions.SET_OD_AGEWISE,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getODCustomerwise = async (role, user) => {
  const endPoint = `${apiBaseUrl}/getODCustomerwise/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint);
  if (responseData) {
    store.dispatch({
      type: actions.SET_OD_CUSTOMERWISE,
      payload: { list: responseData },
    });
  }
  return responseData;
};

// New Product Sales Tabs (with date)
export const getSalesNewProduct = async (role, user, fromDate, toDate) => {
  const endPoint = `${apiBaseUrl}/getSalesNewProduct/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint, {
    fromDate: formatDate(fromDate),
    toDate: formatDate(toDate),
  });
  if (responseData) {
    store.dispatch({
      type: actions.SET_SALES_NEW_PRODUCT,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getSalesNewProductReport = async (role, user, fromDate, toDate) => {
  const endPoint = `${apiBaseUrl}/getSalesNewProductReport/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint, {
    fromDate: formatDate(fromDate),
    toDate: formatDate(toDate),
  });
  if (responseData) {
    const parsedData = JSON.parse(responseData)
    console.log(parsedData.slice(0, 12))
    store.dispatch({
      type: actions.SET_SALES_NEW_PRODUCT_REPORT,
      payload: { list: parsedData },
    });
  }
  return responseData;
};

// Sales Order Pending Tabs (no date)
export const getSOCategorywise = async (role, user) => {
  const endPoint = `${apiBaseUrl}/getSOCategorywise/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint);
  if (responseData) {
    store.dispatch({
      type: actions.SET_SO_CATEGORYWISE,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getSOCustomerwise = async (role, user) => {
  const endPoint = `${apiBaseUrl}/getSOCustomerwise/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint);
  if (responseData) {
    store.dispatch({
      type: actions.SET_SO_CUSTOMERWISE,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getSOExecutivewise = async (role, user) => {
  const endPoint = `${apiBaseUrl}/getSOExecutivewise/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint);
  if (responseData) {
    store.dispatch({
      type: actions.SET_SO_EXECUTIVEWISE,
      payload: { list: responseData },
    });
  }
  return responseData;
};

// Sales Trend Tabs (no date)
export const getSalesCustomerwise = async (role, user) => {
  const endPoint = `${apiBaseUrl}/getSalesCustomerwise/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint);
  if (responseData) {
    store.dispatch({
      type: actions.SET_SALES_CUSTOMERWISE,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getSalesCategorywise = async (role, user) => {
  const endPoint = `${apiBaseUrl}/getSalesCategorywise/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint);
  if (responseData) {
    store.dispatch({
      type: actions.SET_SALES_CATEGORYWISE,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getSalesProductCategorywise = async (role, user) => {
  const endPoint = `${apiBaseUrl}/getSalesProductCategorywise/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint);
  if (responseData) {
    store.dispatch({
      type: actions.SET_SALES_PRODUCT_CATEGORYWISE,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getSalesStatewise = async (role, user) => {
  const endPoint = `${apiBaseUrl}/getSalesStatewise/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint);
  if (responseData) {
    store.dispatch({
      type: actions.SET_SALES_STATEWISE,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getSalesCustomerCategorywise = async (role, user) => {
  const endPoint = `${apiBaseUrl}/getSalesCustomerCategorywise/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint);
  if (responseData) {
    store.dispatch({
      type: actions.SET_SALES_CUSTOMER_CATEGORYWISE,
      payload: { list: responseData },
    });
  }
  return responseData;
};

//review
export const getReviewTargetvsActualSales = async (role, user, fromDate, toDate) => {
  const endPoint = `${apiBaseUrl}/GetReviewTargetvsActualSales/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint, {
    fromDate: formatDate(fromDate),
    toDate: formatDate(toDate),
  });
  if (responseData) {
    store.dispatch({
      type: actions.SET_REVIEW_TARGET_VS_ACTUAL_SALES,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getReviewExecutiveWiseOSODPercentage = async (role, user, fromDate, toDate) => {
  const endPoint = `${apiBaseUrl}/GetReviewExecutiveWiseOSODPercentage/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint, {
    fromDate: formatDate(fromDate),
    toDate: formatDate(toDate),
  });
  if (responseData) {
    store.dispatch({
      type: actions.SET_REVIEW_EXEC_OSOD_PERCENTAGE,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getReviewIncentiveTargetvsActualCollection = async (role, user, fromDate, toDate) => {
  const endPoint = `${apiBaseUrl}/GetReviewIncentiveTargetvsActualCollection/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint, {
    fromDate: formatDate(fromDate),
    toDate: formatDate(toDate),
  });
  if (responseData) {
    store.dispatch({
      type: actions.SET_REVIEW_INCENTIVE_TARGET_VS_ACTUAL,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getReviewSalesOrderPending = async (role, user, fromDate, toDate) => {
  const endPoint = `${apiBaseUrl}/GetReviewSalesOrderPending/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint, {
    fromDate: formatDate(fromDate),
    toDate: formatDate(toDate),
  });
  if (responseData) {
    store.dispatch({
      type: actions.SET_REVIEW_SALES_ORDER_PENDING,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getReviewCategoryWiseSales = async (role, user, fromDate, toDate) => {
  const endPoint = `${apiBaseUrl}/GetReviewCategoryWiseSales/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint, {
    fromDate: formatDate(fromDate),
    toDate: formatDate(toDate),
  });
  if (responseData) {
    store.dispatch({
      type: actions.SET_REVIEW_CATEGORY_WISE_SALES,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getReviewCustomerWiseSalesQtyValue = async (role, user, fromDate, toDate) => {
  const endPoint = `${apiBaseUrl}/GetReviewCustomerWiseSalesQtyValue/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint, {
    fromDate: formatDate(fromDate),
    toDate: formatDate(toDate),
  });
  if (responseData) {
    store.dispatch({
      type: actions.SET_REVIEW_CUSTOMER_WISE_SALES_QTY_VALUE,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getReviewDistributorTargetvsActual = async (role, user, fromDate, toDate) => {
  const endPoint = `${apiBaseUrl}/GetReviewDistributorTargetvsActual/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint, {
    fromDate: formatDate(fromDate),
    toDate: formatDate(toDate),
  });
  if (responseData) {
    store.dispatch({
      type: actions.SET_REVIEW_DISTRIBUTOR_TARGET_VS_ACTUAL,
      payload: { list: responseData },
    });
  }
  return responseData;
};

export const getReviewCategoryWiseSalesValue = async (role, user, fromDate, toDate) => {
  const endPoint = `${apiBaseUrl}/GetReviewCategoryWiseSalesValue/${role}/${user}`;
  const { data: responseData } = await handleAxiosGet(endPoint, {
    fromDate: formatDate(fromDate),
    toDate: formatDate(toDate),
  });
  if (responseData) {
    store.dispatch({
      type: actions.SET_REVIEW_CATEGORY_WISE_SALES_VALUE,
      payload: { list: responseData },
    });
  }
  return responseData;
};